@if (guide.active()) {
  <div class="guide-shade" [class.guide-shade--cutout]="guide.target()"></div>
  @if (guide.target(); as target) {
    <div
      class="guide-ring"
      [style.top.px]="target.top"
      [style.left.px]="target.left"
      [style.width.px]="target.width"
      [style.height.px]="target.height"
    ></div>
  }
  @if (guide.step(); as step) {
    @if (guide.card(); as card) {
      <div
        class="guide-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="guide-title"
        [style.top.px]="card.top"
        [style.left.px]="card.left"
      >
        <p class="guide-progress">{{ guide.index() + 1 }} de {{ guide.stepCount() }}</p>
        <h2 id="guide-title">{{ step.title }}</h2>
        <p class="guide-body">{{ step.body }}</p>
        <div class="guide-actions">
          @if (guide.index() > 0) {
            <button mat-button type="button" (click)="guide.back()">Atrás</button>
          }
          <button mat-button type="button" (click)="guide.skip()">Omitir</button>
          <button mat-flat-button color="primary" type="button" (click)="guide.next()">
            {{ guide.index() + 1 === guide.stepCount() ? 'Listo' : 'Siguiente' }}
          </button>
        </div>
      </div>
    }
  }
}
